<template>
  <div id="app">
    <Header></Header>

    <section class="spread" v-if="loading">
      <grid-loader :color="'rgba(0, 0, 0, .1)'"></grid-loader>
    </section>

    <section class="spread" v-else-if="networkError">
      <NetworkAlert :title="'Réseau indisponible'" defaultLink='refresh'>
        <p>
          Une erreur réseau est survenue,
          <br>veuillez réessayer plus tard.
        </p>
      </NetworkAlert>
    </section>

    <router-view v-else />

    <Footer></Footer>
  </div>
</template>

<script>
import store from '@/store'

import MultiTenantService from '@/services/MultiTenantService'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import NetworkAlert from '@/components/NetworkAlert.vue'

import '@/assets/css/container_sections.css'
import '@/assets/css/links.css'

export default {
  components: {
    Header,
    Footer,
    GridLoader,
    NetworkAlert
  },
  data () {
    return {
      tenantCode: '',
      loading: true,
      networkError: false
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log('[ROOT_API]', process.env.ROOT_API)
    }

    if (this.$route.params.tenantCode) {
      this.tenantCode = this.$route.params.tenantCode
    }

    new MultiTenantService()
      .retrieveAuthorization(this.tenantCode)
      .then(data => {
        store.state.multiTenantAuthorization = { 'X-TenantId': data.tenantId }
        this.loading = false

        if (process.env.NODE_ENV === 'development') {
          console.log('[MULTITENANT] GET TENANT_ID', this.tenantCode, data)
          console.log('[MULTITENANT] MISE EN CACHE', store.state.multiTenantAuthorization)
        }
      })
      .catch(error => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[MULTITENANT] ERREUR LORS DE LA RÉCUPERATION DU TENANT_ID', this.tenantCode)
        }

        console.log(error)
        this.networkError = true
        this.loading = false
      })
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  --primary-light: rgb(79, 126, 179);
  --primary-dark: #1d3f5f;
  --secondary-light: rgb(255, 155, 5);
  --secondary-dark: rgb(173, 104, 0);
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  font-family: "Overpass", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f9f9f9;
}

#app .header + div {
  flex: 1;
  margin: 4rem 0;
}

#app h1 {
  flex: 1;
  font-size: 1.7rem;
  text-align: center;
}

#app h2 {
  font-size: 2rem;
  font-weight: normal;
  padding: .5rem 1rem;
  text-align: left;
  line-height: 3rem;
  letter-spacing: -.05rem;
}

#app h3 {
  font-size: 1.6rem;
  line-height: 2.3rem;
  margin-bottom: 2rem;
  text-align: left;
  color: var(--primary-dark);
}

#app > section {
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

@media (max-width: 1300px) {
  #app h2 {
    font-size: 1.5rem;
    line-height: 1.8rem;
  }
}

@media (max-width: 1000px) {
  #app .header + div {
    margin: .3rem 0;
  }

  #app h2 {
    font-size: 1.8rem;
    line-height: 2rem;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #app {
    display: block;
  }

  #app h3 {
    color: #1d3f5f; /* IE */
  }

  #app section {
    min-height: 73vh;
  }

  #app h2 {
    display: inline-block;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue